import { View } from './view';

export const EditableItem = View;
